export enum ACTION_TYPE {
    add = 'ADD',
    del = 'DELETE',
    change = 'CHANGE',
}